export default "__VITE_ASSET__TbTqZkgC__"